/**
 * Origin'ы, которым разрешено слать BRANDING_PREVIEW через postMessage (§8).
 * Валидация origin обязательна с обеих сторон.
 */
export const ALLOWED_PREVIEW_ORIGINS: readonly string[] = [
  window.location.origin,
  ...(import.meta.env.VITE_ADMIN_ORIGIN
    ? [import.meta.env.VITE_ADMIN_ORIGIN as string]
    : import.meta.env.DEV
      ? ['http://localhost:5174'] // dev-админка по умолчанию
      : []),
];
